import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import SubCategoryIcon from "./SubCategoryIcon";
import { useLocation, useNavigate } from "react-router";
import FileSaver from "file-saver";

const SubCategories = ({
  subCategories,
  categoryName,
  setSelectedSubCategoryId,
  selectedSubCategoryId,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const yourArray = [
    { id: 1, icon: "/business.png", name: "Información de la empresa" },
    {
      id: 2,
      icon: "/Book.svg",
      name: "Guía de herramienta huella de comunicación",
    },
    {
      id: 3,
      icon: "/download-alt.png",
      name: "Descarga de herramienta huella de comunicación",
    },
    { id: 4, icon: "/history_data.png", name: "Histórico de data" },
  ];

  const [singleSelectedCategory, setSingleSelectedCategory] = useState(null);
  const onSingleSubCategoryClick = (item) => {
    if (item?.name === "Descarga de herramienta huella de comunicación") {
      window.open(subCategories[0]?.tool_guide_file, "_blank");
    } else {
      navigate("/dashboard/tool_guide", { state: { selectedOption: item } });
    }
  };
  const desiredId = 16;

  const foundSubCategory = subCategories?.find(
    (category) => category?.id === desiredId
  );

  return (
    <Box>
      <Typography sx={{ fontSize: "24px" }}>
        <b>Filtro:</b>{" "}
        {categoryName.length > 90 ? categoryName.slice(0, 90) : categoryName}
      </Typography>
      <List>
        {subCategories?.length &&
          subCategories?.map((subCategoryInfo, index) => {
            // Check if the current subCategoryInfo is the foundSubCategory
            const isFoundSubCategory =
              foundSubCategory && foundSubCategory.id === subCategoryInfo.id;

            return (
              <>
                <Typography
                  sx={{
                    display: "flex",
                    columnGap: "7px",
                    maxWidth: "300px",
                    mb: "14px",
                    cursor: "pointer",
                    color: selectedSubCategoryId[subCategoryInfo?.id]
                      ? subCategoryInfo?.color_code
                      : "black",
                    fontWeight: selectedSubCategoryId[subCategoryInfo?.id]
                      ? "bold"
                      : "normal",
                  }}
                  key={subCategoryInfo?.id}
                >
                  <SubCategoryIcon
                    variant={"sm"}
                    color={subCategoryInfo?.color_code}
                  />

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      onClick={() => {
                        {
                          isFoundSubCategory
                            ? navigate("/dashboard/tool_guide")
                            : setSelectedSubCategoryId((prevState) => {
                                const updatedState = { ...prevState };
                                if (updatedState[subCategoryInfo?.id]) {
                                  delete updatedState[subCategoryInfo?.id];
                                } else {
                                  updatedState[subCategoryInfo?.id] =
                                    subCategoryInfo;
                                }

                                const selectedSubcategoryIds =
                                  Object.keys(updatedState);

                                return updatedState;
                              });
                        }
                      }}
                    >
                      {" "}
                      {subCategoryInfo?.name}
                    </div>{" "}
                  </div>
                </Typography>
              </>
            );
          })}
      </List>
    </Box>
  );
};

export default SubCategories;
